module.exports = __webpack_public_path__ + "img/ícone-seta-direita.1ef12750.svg";